import { useTranslation } from 'react-i18next';

import { Button } from '@frontierag/frontier-ui-library';
import { useFormikContext } from 'formik';

import type { IAddToBasket } from './types';

export default function AddToBasket({ disabled }: IAddToBasket) {
  const { t } = useTranslation('CreateOrder');
  const { isValid } = useFormikContext();

  return (
    <Button
      fullWidth
      type="submit"
      color="secondary"
      variant="contained"
      disabled={!isValid || disabled}
    >
      {t('ProductForm.buttons.addToBasket')}
    </Button>
  );
}
